// src/core/hooks/usePlatform.ts
// React 컴포넌트에서 플랫폼 정보를 사용하기 위한 훅

import { useMemo } from "react"
import { getPlatformBridge, type PlatformFeature, type PlatformType } from "@core/platform"

interface UsePlatformResult {
  /** 현재 플랫폼 타입 */
  platform: PlatformType
  /** Electron 환경 여부 */
  isElectron: boolean
  /** Capacitor(Android) 환경 여부 */
  isCapacitor: boolean
  /** 웹 환경 여부 */
  isWeb: boolean
  /** 특정 기능의 사용 가능 여부 확인 */
  isFeatureAvailable: (feature: PlatformFeature) => boolean
  /** 플랫폼 브릿지 인스턴스 */
  bridge: ReturnType<typeof getPlatformBridge>
}

/** 플랫폼 감지 및 기능 가용성 훅 */
export function usePlatform(): UsePlatformResult {
  const bridge = useMemo(() => getPlatformBridge(), [])

  return useMemo(
    () => ({
      platform: bridge.platform,
      isElectron: bridge.platform === "electron",
      isCapacitor: bridge.platform === "capacitor",
      isWeb: bridge.platform === "web",
      isFeatureAvailable: (feature: PlatformFeature) => bridge.isFeatureAvailable(feature),
      bridge,
    }),
    [bridge]
  )
}
